import { combineReducers } from 'redux';
import userIdentityReducer from '../commonReducers/userIdentityReducer';
import userObjectReducer from '../commonReducers/userObjectReducer';
import userHashReducer from '../commonReducers/userHashReducer';
import communicationPreferencesReducer from '../commonReducers/communicationPreferencesReducer';
import feedbackDataReducer from './feedbackDataReducer';
import translationDataReducer from '../commonReducers/translationDataReducer';
import configsDataReducer from '../commonReducers/configsDataReducer';
import queryParamsReducer from '../commonReducers/queryParamsReducer';
import ssoReducer from '../commonReducers/ssoReducer';

const allReducers = combineReducers({
  userIdentityDetails: userIdentityReducer,
  userObject: userObjectReducer,
  userHash: userHashReducer,
  preferencesData: communicationPreferencesReducer,
  feedbackData: feedbackDataReducer,
  translationsData: translationDataReducer,
  configs: configsDataReducer,
  queryParams: queryParamsReducer,
  sso: ssoReducer
});

export default function getStandaloneReducers() {
  return allReducers;
}
